import { combineReducers } from "redux";
import { IntroductionDetail } from "../types";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { FETCH_INTRODUCTION_REQUEST } from "./constants";
import { Action } from "./types";

function item(state: Partial<IntroductionDetail> = {}, action: Action): Partial<IntroductionDetail> {
  switch (action.type) {
    case getSuccessActionType(FETCH_INTRODUCTION_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_INTRODUCTION_REQUEST:
      return true;
    case getSuccessActionType(FETCH_INTRODUCTION_REQUEST):
    case getFailureActionType(FETCH_INTRODUCTION_REQUEST):
      return false;

    default:
      return state;
  }
}

export const introduction = combineReducers({ item, isFetching });
